
import CloseIcon from '~/components/ui/icons/CloseIcon.vue';
import ChevronIcon from '~/components/ui/icons/ChevronIcon.vue';
import { getSymbolTagText } from '@/utils/company-tags.ts';
import { isMobile } from '~/utils/screenSizes';
import ProfileImg from '../atom/ProfileImg.vue';
import TimeIcon from '../icons/TimeIcon.vue';

export default {
  name: 'StockOperationCard',
  components: { CloseIcon, ChevronIcon, ProfileImg, TimeIcon },
  props: {
    symbol: {
      type: Object,
      default: null,
    },
    showCardBackgroundStyle: {
      type: Boolean,
      default: false,
    },
    showCloseIcon: {
      type: Boolean,
      default: false,
    },
    showChevronIcon: {
      type: Boolean,
      default: false,
    },
    chevronDirection: {
      type: String,
      default: 'down',
    },
    showSymbolExchange: {
      type: Boolean,
      default: false,
    },
    labelText: {
      type: String,
      default: '',
    },
    avatarUri: {
      type: String,
      default: '',
    },
    symbolName: {
      type: String,
      default: '',
    },
    symbolType: {
      type: String,
      default: '',
    },
    companyName: {
      type: String,
      default: '',
    },
    exchange: {
      type: String,
      default: '',
    },
    showPriceAndPercentage: {
      type: Boolean,
      default: false,
    },
    showLastUpdated: {
      type: Boolean,
      default: false,
    },
    price: {
      type: Number,
      default: 0,
    },
    changePercent: {
      type: Number,
      default: 0,
    },
    currencySymbol: {
      type: String,
      default: '',
    },
  },
  computed: {
    isMobileSize() {
      return isMobile();
    },
    setBackgroundStyle() {
      if (this.showCardBackgroundStyle) {
        return 'rounded-xl bg-neutral-2';
      }
      return '';
    },
    fromNow() {
      return this.$dayjs(this.symbol.priceDate).fromNow();
    },
    tickerPrice() {
      if (!this.price || !this.currencySymbol) return;
      return this.$display.money.moneyOld(this.price, this.currencySymbol);
    },
  },
  methods: {
    getCompanyTag(companyType) {
      return getSymbolTagText(companyType);
    },
  },
};
